// extracted by mini-css-extract-plugin
module.exports = {"container":"_eN","content":"_eO","text":"_eP","title":"_eQ","link":"_eR","info":"_eS","actions":"_eT","button":"_eU"};